/* ============================================================================
   arte-europea-flow.js
   v6.3 — English CRO Edition (Price Injection & Variant Support)
============================================================================ */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);   const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const prefersReducedMotion = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  /* --------------------------------------------------------------------------
     1. HEADER SHADOW ON SCROLL
  -------------------------------------------------------------------------- */
  function initHeaderShadow() {
    const header = $('.header-wrapper, header');
    if (!header) return;

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          header.classList.toggle('eh-scrolled', window.scrollY > 15);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --------------------------------------------------------------------------
     2. ADD TO CART PRICE INJECTION
  -------------------------------------------------------------------------- */
  function initAddToCartPriceInjection() {
    if (!window.location.pathname.includes('/products/')) return;

    const submitBtn = $('.product-form__submit');
    if (!submitBtn) return;

    function updateButtonPrice() {
      const comparePriceEl = $(
        '.price__sale s.price-item--regular, ' +
        '.price__compare-at .price-item, ' +
        's.price-item--regular, ' +
        '.price--on-sale .price-item--regular, ' +
        '.price__sale s'
      );

      const currentPriceEl = $(
        '.price__sale .price-item--sale, ' +
        '.price__sale .price-item--last, ' +
        '.price-item--sale'
      );

      const rawOld = comparePriceEl ? comparePriceEl.textContent.trim() : '';
      const rawNew = currentPriceEl ? currentPriceEl.textContent.trim() : '';

      const cleanPrice = (str) => str.replace(/\s*EUR|\s*USD/g, '').trim();
      const label = submitBtn.querySelector('span:not(.hidden)') || submitBtn;

      if (rawOld && rawNew && rawOld !== rawNew) {
        label.innerHTML = `ADD TO CART — <span class="eh-btn-price-wrapper"><span class="eh-btn-old-price">${cleanPrice(rawOld)}</span> <span class="eh-btn-new-price">${cleanPrice(rawNew)}</span></span>`;
      } else if (rawNew) {
        label.innerHTML = `ADD TO CART — <span class="eh-btn-price-wrapper"><span class="eh-btn-new-price">${cleanPrice(rawNew)}</span></span>`;
      } else {
        const fallbackPrice = $('.price-item--regular')?.textContent?.trim() || '';
        if (fallbackPrice) {
          label.innerHTML = `ADD TO CART — <span class="eh-btn-price-wrapper"><span class="eh-btn-new-price">${cleanPrice(fallbackPrice)}</span></span>`;
        }
      }
    }

    updateButtonPrice();

    const priceContainer = $('.price, .product__price, .price-container');
    if (priceContainer) {
      const observer = new MutationObserver(() => {
        setTimeout(updateButtonPrice, 60);
      });
      observer.observe(priceContainer, { childList: true, subtree: true, characterData: true });
    }
  }

  /* --------------------------------------------------------------------------
     3. STICKY BUY BAR
  -------------------------------------------------------------------------- */
  function initStickyBuyBar() {
    if (isDesktop() || $('#eh-buybar') || !window.location.pathname.includes('/products/')) return;

    const submitBtn = $('.product-form__submit');
    if (!submitBtn) return;

    const titleEl = $('.product__title h1, .product__title');
    const title = titleEl ? titleEl.textContent.trim().split('\n')[0] : '';
    const price = $('.price-item--regular, .price-item--sale')?.textContent?.trim() || '';
    const img = $('.product__media img, .product-single__photo img');
    const src = img?.currentSrc || img?.src || '';

    const bar = document.createElement('div');
    bar.id = 'eh-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `
      ${src ? `<img src="${src}" class="eh-buybar-thumb" alt="${title}">` : ''}
      <div class="eh-buybar-info">
        <div class="eh-buybar-name">${title}</div>
        <div class="eh-buybar-price">${price}</div>
      </div>
      <button type="button" class="eh-buybar-cta">ADD TO CART</button>
    `;

    document.body.appendChild(bar);

    const observer = new IntersectionObserver(([entry]) => {
      const isVisible = !entry.isIntersecting;
      bar.classList.toggle('eh-visible', isVisible);
      bar.setAttribute('aria-hidden', !isVisible);
    }, { threshold: 0 });

    observer.observe(submitBtn);

    bar.querySelector('.eh-buybar-cta').addEventListener('click', () => {
      submitBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => submitBtn.click(), 300);
    });
  }

  /* --------------------------------------------------------------------------
     4. TRUST BADGES
  -------------------------------------------------------------------------- */
  function initTrustBadges() {
    if (!window.location.pathname.includes('/products/') || $('.eh-trust-badges')) return;

    const target = $('.product-form__buttons, .product-form');
    if (!target) return;

    const badges = document.createElement('div');
    badges.className = 'eh-trust-badges';
    badges.innerHTML = `
      <div class="eh-badge-item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        <span>Drop Protection</span>
      </div>
      <div class="eh-badge-item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
        <span>Express Shipping</span>
      </div>
      <div class="eh-badge-item">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>
        <span>30-Day Guarantee</span>
      </div>
    `;

    target.after(badges);
  }

  /* --------------------------------------------------------------------------
     5. CART PULSE
  -------------------------------------------------------------------------- */
  function initCartPulse() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.product-form__submit, .eh-buybar-cta');
      if (!btn) return;

      const cartIcon = $('.header__icon--cart, .cart-count-bubble, [href="/cart"]');
      if (!cartIcon) return;

      cartIcon.classList.remove('eh-pulse');
      void cartIcon.offsetWidth;
      cartIcon.classList.add('eh-pulse');
    });
  }

  /* --------------------------------------------------------------------------
     INIT
  -------------------------------------------------------------------------- */
  function init() {
    try { initHeaderShadow(); } catch (e) {}
    try { initAddToCartPriceInjection(); } catch (e) {}
    try { initStickyBuyBar(); } catch (e) {}
    try { initTrustBadges(); } catch (e) {}
    try { initCartPulse(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();